// extracted by mini-css-extract-plugin
export var numpadContainer = "_rl-1";
export var phoneButton = "_rl-0";